export default __webpack_public_path__ + "b653c6425be334f8bb97e394b999acad.png";